import { AxiosInstance } from "axios"
import { MerchantSurvey, Survey, TopicsListForMerchant } from "./merchantSurveyTypes"

export enum SurveyQuery {
    LIST = "surveys-for-merchant",
    DETAILS = "details-for-survey",
}

type FetchAllSurveysParams = Readonly<{
    merchantId: number | string | undefined
}>

export type FetchAllSurveysResponse = Readonly<{
    surveys: Survey[]
}>

export async function fetchSurveysList(
    { merchantId }: FetchAllSurveysParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchAllSurveysResponse> {
    const url = `/merchants/${merchantId}/surveys`

    const { data } = await axios.get(url, {
        params: {},
        signal,
    })

    return data
}

type MerchantAdminSurveyParam = Readonly<{
    surveyId: string
}>

export type FetchSurveyDetailsResponse = Readonly<{
    survey: MerchantSurvey
}>

export async function fetchSurveyDetails(
    { surveyId }: MerchantAdminSurveyParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchSurveyDetailsResponse> {
    const url = `/surveys/${surveyId}`

    const { data } = await axios.get(url, {
        signal,
    })
    return data
}

type ServiceResponse = Readonly<{
    serviceResponse: {
        displayMessage: string
    }
}>

export async function createSurvey(
    survey: MerchantSurvey,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse> {
    const { data } = await axios.post(
        `/surveys`,
        {
            survey,
        },
        {
            signal,
        },
    )
    return data
}

export async function updateSurvey(
    { survey, surveyId }: { survey: MerchantSurvey; surveyId: string },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse> {
    const { data } = await axios.post(
        `/surveys/${surveyId}`,
        {
            survey,
        },
        {
            signal,
        },
    )
    return data
}
type DeleteMerchantAdminSurveysItemResponse = ServiceResponse

type DeleteMerchantAdminSurveysItemParam = Readonly<{
    surveyId: number
}>

export async function deleteMerchantAdminSurveysItem(
    { surveyId }: DeleteMerchantAdminSurveysItemParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<DeleteMerchantAdminSurveysItemResponse> {
    const { data } = await axios.delete(`/surveys/${surveyId}`, {
        signal,
    })
    return data
}

type FetchTopicsListForMerchantParams = Readonly<{
    merchantId: number
}>

export type FetchTopicsListForMerchantResponse = Readonly<{
    topics: TopicsListForMerchant
}>

export async function fetchTopicsListForMerchant(
    { merchantId }: FetchTopicsListForMerchantParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchTopicsListForMerchantResponse> {
    const url = `/merchants/${merchantId}/surveys/topics`

    const { data } = await axios.get(url, {
        signal,
    })

    return data
}
